import { ITariff } from '../../model/types/ITariff';
import { ITariffType } from '../../model/types/ITariffType';

interface IParams {
  tariff: ITariff;
  activeTariffId?: number;
}

export const getTariffType = ({
  tariff,
  activeTariffId,
}: IParams): ITariffType => {
  if (activeTariffId === tariff.id) return 'your-tariff';
  if (tariff.code === 'business') return 'popular';
  if (tariff.code === 'amateur') return 'focus';
  return 'default';
};
